// src/utils/messageMap.ts
export const messageMap: Record<string, string> = {
  "Account is locked.": "bulkUpload.accountLocked",
  "Missing photo.": "bulkUpload.MissingPhoto",
  "Not Eligible": "bulkUpload.NotEligible",
  "Duplicate Connection Request.": "bulkUpload.AlreadyhasRequest",
  "Request Sent!": "bulkUpload.requestSent",
  "Contact Not Found": "bulkUpload.contactNotFound",
  "Organization not found.": "bulkUpload.OrgNotFound",
  "myCCO Profile incomplete.": "bulkUpload.ProfileIsIncomplete"
};
